import "@/App.css";
import { BrowserRouter, Navigate, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import MarketingLayout from "@/components/marketing/MarketingLayout";
import Home from "@/pages/Home";
import ServiceCategoryPage from "@/pages/ServiceCategoryPage";
import ServiceDetail from "@/pages/ServiceDetail";
import SafetyRecognitionPage from "@/pages/SafetyRecognitionPage";
import SpecialtyPage from "@/pages/SpecialtyPage";
import SafetyPage from "@/pages/SafetyPage";
import AsphaltPage from "@/pages/AsphaltPage";
import CareersPage from "@/pages/CareersPage";
import ContactPage from "@/pages/ContactPage";
import VanguardPage from "@/pages/VanguardPage";
import AboutPage from "@/pages/AboutPage";
import ContentPage from "@/pages/ContentPage";
import ProjectsPage from "@/pages/ProjectsPage";
import RequestPage from "@/pages/RequestPage";
import NewsPage from "@/pages/NewsPage";
import AsphaltInfoPage from "@/pages/AsphaltInfoPage";
import NotFoundPage from "@/pages/NotFoundPage";
import PrivacyTermsPage from "@/pages/PrivacyTermsPage";
import AdminLogin from "@/components/admin/Login";
import AdminDashboard from "@/components/admin/Dashboard";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<MarketingLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Navigate to="/services/heavy-highway-infrastructure" replace />} />
              <Route path="/services/heavy-highway-infrastructure" element={<ServiceCategoryPage category="heavy-highway" />} />
              <Route path="/services/site-work-commercial" element={<ServiceCategoryPage category="site-work" />} />
              <Route path="/services/industrial-specialty" element={<SpecialtyPage />} />
              <Route path="/services/materials-plant-sales" element={<ServiceCategoryPage category="materials-plant-sales" />} />
              <Route path="/services/aviation-port-intermodal" element={<Navigate to="/services/industrial-specialty" replace />} />
              <Route path="/services/mechanical-industrial-services" element={<Navigate to="/services/industrial-specialty" replace />} />
              <Route path="/services/emergency-road-repairs" element={<Navigate to="/services/industrial-specialty" replace />} />
              <Route path="/services/specialty-services" element={<Navigate to="/services/industrial-specialty" replace />} />
              <Route path="/services/earthmoving-grading" element={<Navigate to="/services/complete-site-development" replace />} />
              <Route path="/services/:slug" element={<ServiceDetail />} />
              <Route path="/about" element={<Navigate to="/about/company-history" replace />} />
              <Route path="/about/:page" element={<ContentPage />} />
              <Route path="/projects" element={<ProjectsPage />} />
              <Route path="/projects/:category" element={<ProjectsPage />} />
              <Route path="/safety" element={<SafetyPage />} />
              <Route path="/safety/certifications" element={<SafetyRecognitionPage type="certifications" />} />
              <Route path="/safety/awards" element={<SafetyRecognitionPage type="awards" />} />
              <Route path="/safety/quality-control-labs" element={<Navigate to="/asphalt-plants/quality-control-labs" replace />} />
              <Route path="/safety/:page" element={<ContentPage />} />
              <Route path="/asphalt-sales" element={<AsphaltPage />} />
              <Route path="/asphalt-plants" element={<AsphaltInfoPage />} />
              <Route path="/asphalt-plants/:page" element={<AsphaltInfoPage />} />
              <Route path="/asphalt-plants/quality-control-labs" element={<ContentPage page="quality-control-labs" />} />
              <Route path="/asphalt-plants/order-dispatch" element={<RequestPage />} />
              <Route path="/careers" element={<CareersPage />} />
              <Route path="/careers/:page" element={<ContentPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/contact/headquarters" element={<Navigate to="/asphalt-plants/locations" replace />} />
              <Route path="/contact/regional-offices" element={<Navigate to="/asphalt-plants/locations" replace />} />
              <Route path="/contact/request-a-bid" element={<RequestPage />} />
              <Route path="/vanguard" element={<VanguardPage />} />
              <Route path="/news/vanguard-magazine" element={<VanguardPage />} />
              <Route path="/news" element={<NewsPage />} />
              <Route path="/privacy-terms" element={<PrivacyTermsPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Route>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors closeButton />
      </AuthProvider>
    </div>
  );
}

export default App;
